import { Body, system } from '@hover/blueprint';
import type { FallbackRender } from '@sentry/react';
import type { ReactNode } from 'react';
import React from 'react';
import type { FallbackProps } from 'react-error-boundary';

import { isProduction } from 'src/shared/helpers/environment';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

type FallbackRenderProps = Parameters<FallbackRender>[0];

const ErrorContainer = ({ children }: { children?: ReactNode }) => {
  const t = useTranslate(TranslationNamespace.SHARED);

  return (
    <system.div px="400" py="300">
      <Body>{t('error')}</Body>
      {children}
    </system.div>
  );
};

const Error = ({ error, ...props }: FallbackProps | FallbackRenderProps) => {
  if (isProduction()) return <ErrorContainer />;

  const message = (
    <system.pre>{error.message ?? '[missing error message]'}</system.pre>
  );

  if ('componentStack' in props) {
    return (
      <ErrorContainer>
        {message}
        <system.pre>
          {props.componentStack ?? '[missing call stack]'}
        </system.pre>
      </ErrorContainer>
    );
  }

  return (
    <ErrorContainer>
      {message}
      <system.pre>{error.stack ?? '[missing call stack]'}</system.pre>
    </ErrorContainer>
  );
};

export { Error };
